import { B } from "../data/pillars";

const LEVELS = [
  { n: 1, label: "Reactive",  color: B.red    },
  { n: 2, label: "Emerging",  color: B.orange  },
  { n: 3, label: "Scaling",   color: B.yellow  },
  { n: 4, label: "Proactive", color: B.green   },
  { n: 5, label: "Optimized", color: B.teal    },
];

export default function MaturityRoadmap({ currentScore, targetScore = 4.0 }) {
  const cur = Math.round(currentScore);
  const tgt = Math.round(targetScore);
  return (
    <div style={{ background: "#122240", borderRadius: 12, padding: "20px 24px", marginBottom: 24 }}>
      <div style={{ color: B.subText, fontSize: 11, fontWeight: 700, letterSpacing: 2, marginBottom: 16 }}>YOUR MATURITY JOURNEY</div>
      <div style={{ display: "flex", alignItems: "center" }}>
        {LEVELS.map((lv, i) => (
          <div key={lv.n} style={{ flex: 1, display: "flex", flexDirection: "column", alignItems: "center" }}>
            <div style={{ display: "flex", width: "100%", alignItems: "center" }}>
              {i > 0 && <div style={{ flex: 1, height: 3, background: lv.n <= tgt ? lv.color + "80" : "#1E3A5F" }} />}
              <div style={{
                width: 36, height: 36, borderRadius: "50%", display: "flex", alignItems: "center", justifyContent: "center",
                background: lv.n === cur ? lv.color : lv.n === tgt ? lv.color + "40" : "#1E3A5F",
                border: lv.n === tgt ? `2px solid ${lv.color}` : "2px solid #1E3A5F",
                fontSize: 14, fontWeight: 800, color: lv.n === cur ? B.white : lv.n <= tgt ? lv.color : "#3A5A7A",
                position: "relative", flexShrink: 0,
              }}>
                {lv.n}
                {lv.n === cur && <div style={{ position: "absolute", top: -22, left: "50%", transform: "translateX(-50%)", fontSize: 9, color: lv.color, fontWeight: 800, whiteSpace: "nowrap", background: lv.color + "20", padding: "2px 6px", borderRadius: 4 }}>YOU ARE HERE</div>}
                {lv.n === tgt && lv.n !== cur && <div style={{ position: "absolute", top: -22, left: "50%", transform: "translateX(-50%)", fontSize: 9, color: lv.color, fontWeight: 800, whiteSpace: "nowrap", background: lv.color + "20", padding: "2px 6px", borderRadius: 4 }}>TARGET</div>}
              </div>
              {i < LEVELS.length - 1 && <div style={{ flex: 1, height: 3, background: lv.n < tgt ? lv.color + "80" : "#1E3A5F" }} />}
            </div>
            <div style={{ marginTop: 8, fontSize: 10, color: lv.n === cur ? lv.color : lv.n <= tgt ? B.lightGray : "#3A5A7A", fontWeight: lv.n === cur ? 700 : 500 }}>{lv.label}</div>
          </div>
        ))}
      </div>
    </div>
  );
}